




































import Vue from "vue";
import { historyTableColumns } from './data'
import moment from "moment";

import {DataHistoryServiceProxy,FindDataHistoryVO} from '@/service-proxies/app-v2/iotmodel-storage.service-proxies';
const dataHistoryProxyServ = new DataHistoryServiceProxy();
export default Vue.extend({
  name: 'AttributeHistoryModal',
  props: [],
  data() {
    return {
      visible: false,
      loading: false,
      pagination: {
        total: 0,
      },
      gatewayCode: undefined,
      appCode: undefined,
      propertyName: undefined,
      filter:{
        start: moment().add('day', -1),
        end: moment(),
        current:1,
        size:10,
      },
      dateRange:[moment().add('day', -1), moment()],
      dataList: []
    }
  },
  computed: {
    historyTableColumns() {
      return historyTableColumns.map((item) => {
        return {
          ...item,
          title: this.$t(item.title)
        }
      })
    },
    displayTitle(){
      if(!this.gatewayCode||!this.appCode||!this.propertyName){
        return this.$t('page_getwat_list_historical_data');
      }
      return this.$t('page_getwat_list_historical_data') + `:${this.gatewayCode}-${this.appCode}-${this.propertyName}`
    }
  },
  watch: {
  },
  methods: {
    open(gatewayCode, appCode, propertyName){
      this.dateRange=[moment().add('day', -1), moment()];
      this.filter={
        start: moment().add('day', -1),
        end: moment(),
        current:1,
        size:10,
      }
      this.gatewayCode=gatewayCode;
      this.appCode=appCode;
      this.propertyName=propertyName;
      this.visible=true;
      this.refresh();
    },
    close(){
      this.visible=false;
    },
    dateRangeChange(){
      this.filter.start=this.dateRange[0];
      this.filter.end=this.dateRange[1];
      this.refresh();
    },
    refresh(){

      this.filter.start.hours(0).minutes(0).seconds(0);
      this.filter.end.hours(23).minutes(59).seconds(59);


      const vo = new FindDataHistoryVO();
      vo.init(this.filter);
      vo.gatewayCode=this.gatewayCode;
      vo.appCode=this.appCode;
      vo.propertyName=this.propertyName;
      this.loading=true;
      dataHistoryProxyServ.findDataList(vo)
        .then(res=>{
          this.pagination.total=res.totalCount;
          this.dataList=res.items;
        })
        .finally(()=>{
          this.loading=false;
        });
    },
    handleTableChange(pagination, filters, sorter){
      this.filter.current=pagination.current;
      this.filter.size=pagination.pageSize;
      this.refresh();
    }
  }
})
